import { useEffect, useState } from 'react';
import { finApi } from '../../api/finance.js';

export default function Ledger() {
  const [accounts, setAccounts] = useState([]);
  const [accountId, setAccountId] = useState('');
  const [dateFrom, setDateFrom] = useState(new Date(new Date().getFullYear(), 0, 1).toISOString().slice(0, 10));
  const [dateTo, setDateTo] = useState(new Date().toISOString().slice(0, 10));
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    finApi.accounts({ active: true }).then((d) => setAccounts(d || []));
  }, []);

  async function load() {
    if (!accountId) return;
    setLoading(true); setError(null);
    try {
      const d = await finApi.ledger({ account_id: accountId, date_from: dateFrom, date_to: dateTo });
      setData(d);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed');
    } finally {
      setLoading(false);
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { if (accountId) load(); /* eslint-disable-next-line */ }, [accountId, dateFrom, dateTo]);

  return (
    <section>
      <header className="page-header"><h1>General Ledger</h1></header>

      <div className="card form-card grid-form">
        <label className="full">
          Account
          <select value={accountId} onChange={(e) => setAccountId(e.target.value)}>
            <option value="">Select an account…</option>
            {accounts.map((a) => <option key={a.id} value={a.id}>{a.code} — {a.name} ({a.category_name})</option>)}
          </select>
        </label>
        <label>From<input type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} /></label>
        <label>To<input type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} /></label>
      </div>

      {error && <div className="alert error">{error}</div>}
      {loading && <div className="muted">Loading…</div>}

      {data && (
        <div className="card">
          <div className="ledger-summary">
            <span>Opening: <strong>{data.opening.toFixed(2)}</strong></span>
            <span>Closing: <strong>{data.closing.toFixed(2)}</strong></span>
            <span className="muted">{data.lines.length} entries</span>
          </div>
          <table className="data-table">
            <thead><tr><th>Date</th><th>Entry</th><th>Description</th><th>Debit</th><th>Credit</th><th>Balance</th></tr></thead>
            <tbody>
              {data.lines.map((l) => (
                <tr key={l.id}>
                  <td>{l.entry_date}</td>
                  <td><code>{l.entry_no}</code></td>
                  <td>{l.entry_description || l.notes || '—'}</td>
                  <td>{Number(l.debit) > 0 ? Number(l.debit).toFixed(2) : ''}</td>
                  <td>{Number(l.credit) > 0 ? Number(l.credit).toFixed(2) : ''}</td>
                  <td><strong>{l.running_balance.toFixed(2)}</strong></td>
                </tr>
              ))}
              {data.lines.length === 0 && <tr><td colSpan={6} className="muted">No transactions in this range.</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
